// extracted by mini-css-extract-plugin
export var grid = "HowItWorksModal-module__grid___ij6pn";